import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  tabs: ({ allowScroll, align }) => ({
    display: 'flex',
    width: 'fit-content',
    justifyContent: allowScroll ? 'flex-start' : 'center',
    marginLeft: allowScroll ? '0' : -theme.spacing(1),
    marginRight: allowScroll ? '0' : theme.spacing(1),

    [theme.breakpoints.up('sm')]: {
      justifyContent: align || 'center',
      width: '100%',
    },
  }),
  tab: ({ color }) => ({
    border: 0,
    borderRadius: theme.spacing(2),
    color: color || theme.palette.grey[500],
    cursor: 'pointer',
    fontFamily: theme.typography.overline.fontFamily,
    marginLeft: theme.spacing(0.5),
    paddingTop: 1,
    paddingBottom: 1,
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    textTransform: 'uppercase',
    letterSpacing: 1.5,
    background: 'transparent',

    '&:first-of-type': {
      marginLeft: 0,
    },
  }),
  selected: () => ({
    color: 'white',
    background: theme.palette.secondary.light,
  }),
}))

export default useStyles
